import { useQuery } from '@tanstack/react-query';
import { mealPlanQueryService } from '@/services/mealPlan/mealPlanQueryService';
import { startOfDay, addDays, format } from 'date-fns';

export const useNextScheduledMeal = () => {
  return useQuery({
    queryKey: ['next-scheduled-meal'],
    queryFn: async () => {
      const today = startOfDay(new Date());
      const oneWeekFromNow = addDays(today, 7);
      
      const mealPlans = await mealPlanQueryService.getMealPlans(today, oneWeekFromNow);
      
      if (mealPlans.length === 0) return null;
      
      // Find the earliest upcoming meal - mealPlans are MealPlan[] (base interface)
      const sortedMealPlans = mealPlans
        .sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime());
      
      const nextMeal = sortedMealPlans[0];
      
      // Get recipe names for the next meal
      const recipeNames: string[] = [];
      if (nextMeal.recipeId) {
        // Fetch recipe from database to get the title
        const { supabase } = await import('@/integrations/supabase/client');
        const { data: recipe } = await supabase
          .from('recipes')
          .select('title')
          .eq('id', nextMeal.recipeId)
          .single();
        
        if (recipe) {
          recipeNames.push(recipe.title);
        }
      }
      
      return {
        date: format(new Date(nextMeal.date), 'EEEE, MMM d'),
        recipes: recipeNames,
        mealType: nextMeal.mealType
      };
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};